<div class="ade-detail">
  <div class="ade-detail__loading" *ngIf="isLoading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading && vehicle">
    <div class="ade-detail__container">
      <!-- M11 — Cabeçalho -->
      <div class="ade-detail__header">
        <div class="ade-detail__header-left">
          <h1 class="ade-detail__title">{{ name }}</h1>
          <div class="ade-detail__header-meta">
            <ng-container *ngIf="vehicle.year">
              <span class="ade-detail__header-label">{{
                "ANO" | transloco
              }}</span>
              <span class="ade-detail__header-value">{{ vehicle.year }}</span>
            </ng-container>
            <ng-container *ngIf="showPrices && vehicle.price">
              <span class="ade-detail__header-label">{{
                "PREÇO" | transloco
              }}</span>
              <span
                class="ade-detail__header-value ade-detail__header-value--price"
                >€ {{ vehicle.price | number: "1.0-0" }}</span
              >
            </ng-container>
          </div>
        </div>
        <div class="ade-detail__actions">
          <button
            class="ade-detail__action-btn"
            type="button"
            [attr.aria-label]="'Partilhar' | transloco"
            (click)="share()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
          </button>
          <button
            class="ade-detail__action-btn"
            type="button"
            [attr.aria-label]="'WhatsApp' | transloco"
            (click)="shareWhatsapp()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
              />
            </svg>
          </button>
          <button
            class="ade-detail__action-btn"
            type="button"
            [attr.aria-label]="'Email' | transloco"
            (click)="shareEmail()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
              <rect x="2" y="4" width="20" height="16" rx="2" />
            </svg>
          </button>
        </div>
      </div>

      <!-- M12 — Galeria: imagem principal + thumbs -->
      <div class="ade-detail__gallery" *ngIf="images.length > 0">
        <div class="ade-detail__gallery-main">
          <a
            class="lighbox-image"
            [href]="imgUrl(images[activeImage]?.attributes?.url)"
          >
            <img
              [src]="imgUrl(images[activeImage]?.attributes?.url)"
              [alt]="name"
              class="ade-detail__gallery-img"
            />
          </a>
          <span *ngIf="vehicle?.availability === 'sold'" class="ade-card__badge"
            >VENDIDO</span
          >
          <span
            *ngIf="vehicle?.availability === 'restoration'"
            class="ade-card__badge ade-card__badge--restauro"
            >RESTAURO</span
          >
          <span
            *ngIf="vehicle?.availability === 'reserved'"
            class="ade-card__badge ade-card__badge--reservado"
            >RESERVADO</span
          >
        </div>
        <div class="ade-detail__gallery-thumbs" *ngIf="images.length > 1">
          <div
            *ngFor="let img of thumbImages; let i = index"
            class="ade-detail__thumb"
          >
            <Image
              [src]="img?.attributes?.url"
              [bigSrc]="img?.attributes?.url"
              [alt]="name + ' ' + (i + 1)"
              [full]="true"
            ></Image>
          </div>
        </div>
      </div>

      <!-- Layout 2 colunas -->
      <div class="ade-detail__body">
        <!-- Coluna esquerda: descrição -->
        <div class="ade-detail__left">
          <div class="ade-detail__description-wrap" *ngIf="vehicle.description">
            <div
              class="ade-detail__description"
              [class.ade-detail__description--expanded]="descExpanded"
              [innerHTML]="vehicle.description"
            ></div>
            <button
              class="ade-detail__read-more"
              type="button"
              (click)="descExpanded = !descExpanded"
              *ngIf="vehicle.description?.length > 400"
            >
              {{
                descExpanded
                  ? ("LER MENOS" | transloco)
                  : ("LER MAIS" | transloco)
              }}
            </button>
          </div>
        </div>

        <!-- Coluna direita: ficha técnica sticky -->
        <div class="ade-detail__right">
          <div class="ade-detail__specs-panel">
            <div class="ade-detail__specs-grid">
              <div *ngFor="let f of specs" class="ade-detail__spec-item">
                <span class="ade-detail__spec-label">{{
                  f.label | transloco
                }}</span>
                <span class="ade-detail__spec-value">{{ f.value }}</span>
              </div>
            </div>
            <div
              class="w-full my-8"
              style="background-color: rgb(171, 147, 17); height: 1px"
            ></div>
            <button
              class="ade-detail__cta"
              type="button"
              (click)="showContact = !showContact"
            >
              {{ (showContact ? "FECHAR" : "PEDIR INFORMAÇÃO") | transloco }}
            </button>

            <!-- Formulário de contacto (toggle) -->
            <div class="ade-detail__contact-form" *ngIf="showContact">
              <form
                class="ade-contact-form"
                [formGroup]="contactForm"
                (ngSubmit)="submit()"
                novalidate
              >
                <label class="ade-contact-form__field">
                  <input
                    type="text"
                    formControlName="name"
                    [placeholder]="'Nome' | transloco"
                    required
                  />
                </label>
                <label class="ade-contact-form__field">
                  <input
                    type="email"
                    formControlName="email"
                    [placeholder]="'E-mail' | transloco"
                    required
                  />
                </label>
                <label class="ade-contact-form__field">
                  <input
                    type="text"
                    formControlName="phone"
                    [placeholder]="'Telefone' | transloco"
                  />
                </label>
                <label class="ade-contact-form__field">
                  <textarea
                    rows="4"
                    formControlName="message"
                    [placeholder]="'Mensagem' | transloco"
                    required
                  ></textarea>
                </label>
                <button
                  type="submit"
                  class="ade-contact-form__submit"
                  [disabled]="sending"
                >
                  {{ (sending ? "A enviar..." : "ENVIAR") | transloco }}
                </button>
                <p
                  *ngIf="feedback"
                  class="ade-contact-form__feedback"
                  [class.is-error]="feedbackError"
                >
                  {{ feedback | transloco }}
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Galeria completa -->
  <div
    class="ade-detail__gallery-full"
    *ngIf="!isLoading && vehicle && restImages.length > 0"
  >
    <div class="ade-detail__container">
      <div class="ade-detail__gallery-full-title">
        {{ "Outras fotos" | transloco }}
      </div>
      <div class="ade-detail__gallery-full-grid">
        <div
          *ngFor="let img of restImages; let i = index"
          class="ade-detail__thumb"
        >
          <Image
            [src]="img?.attributes?.url"
            [bigSrc]="img?.attributes?.url"
            [alt]="name + ' ' + (i + thumbCount + 1)"
            [full]="true"
          ></Image>
        </div>
      </div>
    </div>
  </div>

  <div class="ade-detail__empty" *ngIf="!isLoading && !vehicle">
    {{ "Veículo não encontrado." | transloco }}
  </div>
</div>
